import React from 'react';
import {Switch, Route, Redirect} from 'react-router-dom';

import List from './routes/List';

const Giftcards = ({match}) => (
	<div>
		<Switch>
			<Redirect exact from={`${match.url}/`} to={`${match.url}/list`}/>
			<Route path={`${match.url}/list`} component={ List } />
		</Switch>
	</div>
);

export default Giftcards;


// WEBPACK FOOTER //
// ./app/used/giftcards/index.js